<template>
    <div>
        <section>
            <div class="inner row5 resultDetailInner">
                <div class="resultDetailTop">
                    <div class="left">
                        <VueSlickCarousel v-bind="settings" v-if="fileList.length">
                            <div v-for="(file, index) in fileList" :key="index" class="imgBox">
                                <div class="imgBoxOverlay"></div>
                                <img :src="file.PATH" alt="" class="productDetailImg">
                            </div>
                        </VueSlickCarousel>
                    </div>
                    <div class="right">
                        <div class="title">
                            <h1>{{product.NAME}}</h1>
                            <h4>제품 설명</h4>
                            <div>
                                <p v-html="product.DESC"></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="resultDetailbody">
                    <div class="productInfo">
                        <h1 class="mainTitle">제품 정보</h1>
                        <div class="contentsbody">
                            <div class="left">
                                <div class="productInfoItem">
                                    <p>제조구분</p>
                                    <div v-if="product.MANUFACTURE === 'DOMESTIC'" class="productInfoItemcontent">
                                        국내
                                    </div>
                                    <div v-else-if="product.MANUFACTURE === 'OVERSEAS'" class="productInfoItemcontent">
                                        해외
                                    </div>
                                </div>

                                <div class="productInfoItem">
                                    <p>업체명</p>
                                    <div class="productInfoItemcontent">
                                        {{product.COMPANY}}
                                    </div>
                                </div>

                                <div class="productInfoItem">
                                    <p>제품명</p>
                                    <div class="productInfoItemcontent">
                                        {{product.NAME}}
                                    </div>
                                </div>

                                <div class="productInfoItem">
                                    <p>가격</p>
                                    <div class="productInfoItemcontent">
                                        {{product.PRICE_COMMA}}
                                    </div>
                                </div>

                                <div class="productInfoItem">
                                    <p>홈페이지</p>
                                    <div class="productInfoItemcontent" v-html="getHomepageLink(product.HOMEPAGE)"></div>
                                </div>
                            </div>
                            <div class="right">
                                <ul>
                                    <div v-for="index in 10" :key="index">
                                        <li v-if="product['ADD'+index] && additionalItems[index-1]">
                                             <div class="productInfoListTitle">
                                                <p>{{additionalItems[index-1].NAME}}</p>
                                            </div>
                                            <div class="productInfoList">
                                                <p>{{product['ADD'+index]}}</p>
                                            </div>
                                        </li>    
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="productDetailDec">
                        <h1 class="mainTitle">상세설명</h1>
                        <div v-html="product.DETAIL" class="productDetailDecEdit">
                        </div>
                    </div>

                    <div class="corpInfo">
                        <h1 class="mainTitle">기업 정보</h1>
                        <div class="corpInfoTable">
                            <table border="1" border-collapse:>
                                <tbody>
                                    <tr>
                                        <th>
                                            기업명
                                        </th>
                                        <td>
                                            {{product.USER_COMPANY}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            업종
                                        </th>
                                        <td>
                                            {{product.USER_FIELD_TYPE}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            설립연도
                                        </th>
                                        <td>
                                            {{product.USER_BIRTHDAY}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            기업형태
                                        </th>
                                        <td>
                                            {{product.USER_COMPANY_TYPE}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            대표자
                                        </th>
                                        <td>
                                            {{product.USER_NAME}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            주소
                                        </th>
                                        <td>
                                            {{product.USER_ADDRESS}} {{product.USER_ADDRESS_DETAIL}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            대표 번호
                                        </th>
                                        <td>
                                            {{product.USER_PHONE_COMPANY}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            홈페이지
                                        </th>
                                        <td>
                                            {{product.USER_HOMEPAGE}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="resultListBtnBox">
                        <router-link v-if="path.indexOf('/admin') > -1" class="mainBgBtn startBtnFont" to="/admin/productManagement">목 록</router-link>
                        <router-link v-if="path.indexOf('/admin') < 0" class="mainBgBtn startBtnFont" to="/serviceSearch">목 록</router-link>
                    </div>
                </div>
            </div>
        </section>
        
    </div>   
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import {mapActions, mapGetters} from 'vuex'
import * as htmlUtil from '@/utils/htmlUtil'
import * as corpUtil from '@/utils/corpUtil'

export default {
    name: 'ServiceSearchDetail',
    components: {
        VueSlickCarousel 
    },
    mounted(){
        if(this.getUser != null && this.getUser.roleName == 'ROLE_USER'){
            this.requestSearchHistorySubmit({
                categoryIdx : this.$route.params.categoryIdx,
                boardIdx : this.$route.params.idx,
                type : 'PRODUCT'
            })
            .then(() => {
            })
            .catch(() => {
                return []
            });
        }
        
        this.getDatas();
    },
    data(){
        return {
            settings: {
                dots:true,
                arrows:false,
                fade:false,
                speed:1500,
                infinite:true,
                autoplay:false,
                autoplaySpeed:5000,
                pauseOnDotsHover:true,
                swipeToSlide: true,
                "responsive": [
                    {
                    "breakpoint": 560,
                    "settings": {
                        "slidesToShow": 1,
                        "slidesToScroll": 1,
                    }
                    },
                ]
            },
            additionalItems: [],
            product: {},
            fileList: [],
            path : this.$route.fullPath
        }
    },
    watch:{
        product(val){
            if(val.DETAIL != null){
                val.DETAIL = htmlUtil.stringToTag(val.DETAIL)
            }

            if(val.USER_FIELD_TYPE != null){
                for(let i = 0; i < corpUtil.fieldType.length; i++){
                    let item = corpUtil.fieldType[i]
                    if(item.value === val.USER_FIELD_TYPE){
                        val.USER_FIELD_TYPE = item.text
                    }
                }
            }

            if(val.USER_COMPANY_TYPE != null){
                for(let i = 0; i < corpUtil.companyType.length; i++){
                    let item = corpUtil.companyType[i]
                    if(item.value === val.USER_COMPANY_TYPE){
                        val.USER_COMPANY_TYPE = item.text
                    }
                }
            }
        }
    },
    computed:{
        ...mapGetters('auth', [
            'getUser'
        ])
    },
    methods:{
        ...mapActions('product', [
            'requestProductDetail'
        ]),
        ...mapActions('additionalItem',[
            'requestList'
        ]),
        ...mapActions('searchHistory',[
            'requestSearchHistorySubmit'
        ]),
        getHomepageLink(homepage){
            return '<a href='+homepage+' target="_blank">' + homepage + '</a>'
        },
        getDatas(){
            var idx = this.$route.params.idx;
            var status = "";
            var path = "/admin/productManagement";
            if(this.path.indexOf("/admin") < 0){
                path = "/serviceSearch";
                status = "APPROVAL"
            }

            this.requestList('PRODUCT')
            .then((result) => {
                return this.additionalItems = result.data
            })
            .catch(() => {
                return this.additionalItems = []
            })

            this.requestProductDetail({
                idx : idx,
                status : status
                
            })
            .then((result) => {
                this.product = result.data.product;
                this.fileList = result.data.fileList;
            })
            .catch(() => {
                this.$alert('알림', '잘못된 제품 정보입니다.', null, {
                    'closed': () => {
                        this.$router.push({path : path});
                    }
                })
                return []
            });
        }
    },
}

</script>

<style scoped>
    a {
        color: #272727;
    }
    h3 {
        margin: 0 0 16px 0;
    }
    
</style>

<style>
</style>

